<template>
    <layout-card
        :isCustomizable="settings.isCustomizable"
        :loading="loading"
        :type="settings.context"
        :error="error"
        class="card-pur_invoice"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
    >
        <template #title>
            {{ name }}
        </template>

        <template #content>
            <template-kpi-card :data="{ stats: cardData, labels: labels }" />
            <div
                v-if="cardData"
                id="rates"
                class="mt-3 bt-1"
                :class="[ifMultiRate() ? 'pt-1' : 'pt-3']"
            >
                <div v-for="(rate, index) in cardData.rates" :key="index" class="mt-1 pt-1">
                    <h3 class="stats-title mb-2">
                        {{
                            index === 'marginRate'
                                ? $l10n.__('Taux de marge moyen')
                                : $l10n.__('Taux de marque moyen')
                        }}
                    </h3>
                    <div class="data-block-number">
                        <h3 :class="[ifMultiRate() ? 'stats-title' : 'data-value']">
                            {{ $filters.numberFormat(rate) }} %
                        </h3>
                    </div>
                </div>
            </div>
            <Teleport to="#dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </Teleport>
        </template>

        <template #footer>
            <fiscal-year-footer :fiscalYearTimestamp="fiscalYear"></fiscal-year-footer>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import TemplateKpiCard from './TemplateKpiCard.vue';
import CardMixin from './CardMixin.js';
import FiscalYearFooter from './FiscalYearFooter.vue';

export default {
    components: {
        LayoutCard,
        TemplateKpiCard,
        FiscalYearFooter,
    },
    mixins: [CardMixin],
    data() {
        return {
            labels: {
                due: {
                    label: this.$l10n.__('À régler'),
                    labelCount: this.$l10n.__('Factures'),
                },
            },
            settingsFormName: 'pur-invoice-setting-form',
        };
    },
    methods: {
        ifMultiRate() {
            return Object.keys(this.cardData.rates).length >= 2;
        },
    },
};
</script>
